import React, { forwardRef, PropsWithChildren } from 'react';
import classNames from 'classnames';
import { useIsMobile } from 'Hooks/Common';

export enum ContentPosition {
  TOP = 'top',
  BOTTOM = 'bottom',
  LEFT = 'left',
  RIGHT = 'right',
}

export type TooltipBlockProps = PropsWithChildren<{
  contentPosition?: ContentPosition;
  className?: string;
  disabledMobile?: boolean;
}>;

const TooltipBlock = forwardRef<HTMLDivElement, TooltipBlockProps>(
  (
    {
      contentPosition = ContentPosition.TOP,
      children,
      className,
      disabledMobile = false,
    }: PropsWithChildren<TooltipBlockProps>,
    ref,
  ) => {
    const isMobile = useIsMobile();

    return (
      <div
        ref={ref}
        className={classNames(
          'text-tooltip__container',
          {
            'text-tooltip__container--top': contentPosition === ContentPosition.TOP,
            'text-tooltip__container--bottom': contentPosition === ContentPosition.BOTTOM,
            'text-tooltip__container--left': contentPosition === ContentPosition.LEFT,
            'text-tooltip__container--right': contentPosition === ContentPosition.RIGHT,
            mobile: isMobile && !disabledMobile,
          },
          className,
        )}
      >
        {children}
      </div>
    );
  },
);

TooltipBlock.displayName = TooltipBlock.name;

export default TooltipBlock;
